module.exports = __webpack_public_path__ + "static/media/006.e331bc36.jpg";